<script setup lang="ts">
import { computed } from 'vue'
import { heroCourtSvgUri, stripRegionPrefix, venueBoardTone, venueInitial } from '../services/venue-visual'

const props = defineProps<{ name: string; image?: string; images?: string[]; compact?: boolean; toneKey?: string; province?: string; city?: string; district?: string }>()
const boardColor = computed(() => venueBoardTone(props.toneKey || props.name))
const initial = computed(() => venueInitial(stripRegionPrefix(props.name, props)))
const photoCount = computed(() => props.images?.length || (props.image ? 1 : 0))
const courtSvg = heroCourtSvgUri()
</script>
<template>
  <div class="wx-venue-hero" :class="{ compact }" :style="image ? { backgroundImage:`url(${image})` } : { backgroundColor: boardColor }">
    <img v-if="!image" class="wx-court-perspective" :src="courtSvg" alt="" aria-hidden="true" />
    <strong v-if="!image" class="wx-venue-watermark">{{ initial }}</strong>
    <div class="wx-venue-scrim"></div>
    <span class="wx-venue-gallery">▣ {{ photoCount ? `1 / ${photoCount}` : '暂无实拍' }}</span>
  </div>
</template>
